
import ServicesHero from './components/ServicesHero';
import ServicesGrid from './components/ServicesGrid';
import WhyChooseServices from './components/WhyChooseServices';
import ServicesCTA from './components/ServicesCTA';

export default function ServicesPage() {
  return (
    <div className="min-h-screen">
      <ServicesHero />
      <ServicesGrid />
      <WhyChooseServices />
      <ServicesCTA />
    </div>
  );
}